/**
 * CollabPackets – liste over promo-pakker. Opprett/rediger åpner egne sider.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function CollabPackets() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  const load = () => {
    api.get("/collab/promo-packets").then((r) => setItems(r.data?.results || [])).catch(() => setItems([]));
  };
  useEffect(load, []);

  return (
    <section data-testid="collab-packets">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-fraunces italic text-2xl text-[var(--cream)]">{t("collab.packets_title")}</h2>
        <Link to="/skaper/samarbeid/pakker/ny" className="btn-magenta inline-flex items-center gap-1.5"
          data-testid="packet-new-btn">
          <Plus className="h-3.5 w-3.5" /> {t("collab.new_packet")}
        </Link>
      </div>
      <p className="text-sm text-[var(--cream-soft)] mb-6">{t("collab.packets_subtitle")}</p>

      {items.length === 0 ? (
        <div className="panel-tight p-8 text-center text-[var(--cream-soft)] font-fraunces italic">
          {t("collab.no_packets")}
        </div>
      ) : (
        <ul className="space-y-3">
          {items.map((p) => (
            <li key={p.id} className="panel-tight p-4" data-testid={`packet-${p.id}`}>
              <div className="flex items-baseline justify-between gap-3 mb-2">
                <h3 className="font-fraunces italic text-xl text-[var(--cream)]">{p.title}</h3>
                <div className="flex gap-2">
                  <Link to={`/skaper/samarbeid/pakker/${p.id}/rediger`} className="text-xs font-meta text-[var(--magenta)] hover:underline">
                    {t("common.edit")}
                  </Link>
                  <button onClick={async () => {
                    if (!window.confirm(t("collab.confirm_delete_packet"))) return;
                    await api.delete(`/collab/promo-packets/${p.id}`);
                    toast.success(t("collab.packet_deleted"));
                    load();
                  }} className="text-xs font-meta text-red-300 hover:underline">
                    {t("common.delete")}
                  </button>
                </div>
              </div>
              <div className="flex flex-wrap gap-1 mb-3">
                {p.platforms.map((pl) => (
                  <span key={pl} className="font-meta text-[10px] px-2 py-0.5 border border-white/15 text-[var(--cream-soft)]">
                    {pl.toUpperCase()}
                  </span>
                ))}
              </div>
              <div className="text-xs text-[var(--cream-faint)] mb-1">
                {t("collab.text_variants_count", { count: p.text_variants?.length || 0 })} · {t("collab.media_count", { count: p.media_urls?.length || 0 })}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
